/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_polygon_edit_name_label = /** @type {(inputs: {}) => string} */ () => {
	return `Nombre de la cuenta`
};

const en_accounts_polygon_edit_name_label = /** @type {(inputs: {}) => string} */ () => {
	return `Account name`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_polygon_edit_name_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_polygon_edit_name_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_polygon_edit_name_label", locale)
	if (locale === "es") return es_accounts_polygon_edit_name_label(inputs)
	return en_accounts_polygon_edit_name_label(inputs)
};
export { accounts_polygon_edit_name_label as "accounts.polygon.edit_name_label" }